var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0949 10.4859C14.1046 10.4956 17.1123 13.504 17.1123 13.504C17.988 14.8408 16.0498 16.5436 15.006 17.0888C13.8366 17.6999 12.1421 17.0353 11.0212 16.5367C9.01773 15.6464 7.2795 14.3089 5.73711 12.7665C4.01069 11.0532 2.46136 9.22265 1.46412 6.97886C0.965498 5.85731 0.300903 4.16353 0.911331 2.99407C1.45648 1.9496 3.15998 0.0120676 4.49681 0.887778L7.51423 3.90519C8.64758 5.03855 6.32532 6.42191 6.32462 7.39553C6.32393 8.04832 6.69338 8.63722 7.02741 9.17126C7.42395 9.80391 7.94062 10.3567 8.54688 10.7914C9.1212 11.2039 9.87399 11.6769 10.6053 11.6762C11.5782 11.6755 12.9615 9.35251 14.0949 10.4859Z",
    fill: "#CACED0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d96195a4.svg";
export { ForwardRef as ReactComponent };